import { call, put, takeEvery, getContext } from "redux-saga/effects";

import {
  forgotPasswordSendEmailSuccess,
  forgotPasswordSendEmailFailure,
  forgotPasswordRestoreSuccess,
  forgotPasswordRestoreFailure,
} from "./actions";
import {
  forgotPasswordRestoreActionTypes,
  forgotPasswordSendEmailActionTypes,
} from "./actionTypes";
import { CONTEXT } from "@const/redux";
import {
  resendVerificationLinkFailure,
  resendVerificationLinkSuccess,
} from "../verification/actions";

const sendForgotPasswordEmailAsync = ({ VerificationsService, email }) => {
  if (!VerificationsService) {
    console.log("Required services does not exist");
    return null;
  }

  return VerificationsService.sendRestorePasswordEmail({ email });
};

function* sendForgotPasswordEmail({ payload: { email } }) {
  try {
    const { VerificationsService } = yield getContext(CONTEXT.SERVICES);

    yield call(sendForgotPasswordEmailAsync, {
      VerificationsService,
      email,
    });

    yield put(forgotPasswordSendEmailSuccess());
    yield put(resendVerificationLinkSuccess());
  } catch ({ error }) {
    yield put(forgotPasswordSendEmailFailure(error));
    yield put(resendVerificationLinkFailure(error));
  }
}

const restorePasswordAsync = ({
  VerificationsService,
  password,
  email,
  code,
}) => {
  if (!VerificationsService) {
    console.log("Required services does not exist");
    return null;
  }

  return VerificationsService.restorePassword({ password, email, code });
};

function* restorePassword({ payload: { password, email, code } }) {
  try {
    const { VerificationsService } = yield getContext(CONTEXT.SERVICES);

    yield call(restorePasswordAsync, {
      VerificationsService,
      password,
      email,
      code,
    });
    yield put(forgotPasswordRestoreSuccess());
  } catch ({ error }) {
    yield put(forgotPasswordRestoreFailure(error));
  }
}

export function* watchForgotPassword() {
  yield takeEvery(
    forgotPasswordSendEmailActionTypes.request,
    sendForgotPasswordEmail,
  );
}

export function* watchRestorePassword() {
  yield takeEvery(forgotPasswordRestoreActionTypes.request, restorePassword);
}
